import { defineMessages } from 'react-intl';

export default defineMessages({
  activationDescription: {
    description: 'Activation Modal > Description',
    defaultMessage:
      'You can now activate our enhanced returns and exchanges functionality for any or all of the listed stores. When activating, you will need to reauthenticate your store connection to give ShipStation the necessary permissions.',
    id: 'jD3xBF',
  },
  activateButton: {
    description: 'Activation Modal > Activate Button',
    defaultMessage: 'Activate',
    id: 'BJS4IB',
  },
  activateCarriersButton: {
    description: 'Activation Modal > Activate Carriers Button',
    defaultMessage: 'Activate Carriers',
    id: 'hbkuPp',
  },
  bannerContent: {
    description: 'Activation Modal > Banner Content',
    defaultMessage:
      'To use enhanced returns and exchanges you must have at least one connected carrier, as labels for returns and exchanges rely on these services.',
    id: '5wrMfa',
  },
  bannerHeader: {
    description: 'Activation Modal > Banner Header',
    defaultMessage: 'Carriers Not Activated',
    id: 'WUlpLe',
  },
  noStores: {
    description: 'Activation Modal > No Stores',
    defaultMessage: 'To get started with returns, you’ll need to connect your <b>Shopify</b> store.',
    id: 'yjQE5q',
  },
  connectStoreButton: {
    description: 'Activation Modal > Connect Store Button',
    defaultMessage: 'Connect Store',
    id: 'P6cA7U',
  },
  storeName: {
    description: 'Activation Modal > Store Name',
    defaultMessage: '{name} Store',
    id: 'VvzoWa',
  },
  featureLimitations: {
    description: 'Activation Modal > Feature Limitations',
    defaultMessage: 'The Returns & Exchanges feature is currently available for Shopify only.',
    id: 'jYOKhl',
  },
  accountCreationFailureMessage: {
    description: 'Activation Modal > Account Creation Failure Message',
    defaultMessage: 'We ran into a problem while trying to activate returns. Please refresh the page and try again.',
    id: '8WEFle',
  },
  inProgress: {
    description: 'Activation Modal > In Progress Button Message',
    defaultMessage: 'In Progress',
    id: 'pdm2vN',
  },
  retryButton: {
    description: 'Activation Modal > Retry Button',
    defaultMessage: 'Retry',
    id: 'a741Wy',
  },
  authenticatedButton: {
    description: 'Activation Modal > Authenticated Button',
    defaultMessage: 'Authenticated',
    id: 'qeklKy',
  },
  deactivationRequestedButton: {
    description: 'Activation Modal > Deactivation Requested Button',
    defaultMessage: 'Deactivating',
    id: 'lPfDDU',
  },
  tokenMissingMessage: {
    description: 'Activation Modal > Token Missing Message',
    defaultMessage: 'User is missing proper authentication to proceed with Returns setup. Please contact support.',
    id: 'bHURI8',
  },
});
